import { useEffect, useRef, useState } from 'react'
import {
  Alert,
  AlertProps,
  Button,
  CodeAreaField,
  Dialog,
  DialogContent,
  DialogHeader
} from '@carto/meridian-ds/components'
import { CartoApiError } from 'features/common/errors'
import { Box } from '@mui/material'

interface ErrorAlertProps {
  error: CartoApiError
  alertContent?: AlertProps['content']
  customAction?: React.ReactNode
}

function ErrorAlert({ error, alertContent, customAction }: ErrorAlertProps) {
  const [showMoreDetails, setShowMoreDetails] = useState(false)
  const { code, detail, error: message, title, severity = 'error' } = error
  const alertRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (alertRef.current) {
      alertRef.current?.scrollIntoView?.(false)
    }
  }, [alertRef])
  return (
    <>
      <Alert
        ref={alertRef}
        severity={severity}
        title={title}
        content={alertContent}
        action={
          detail && (
            <Button variant="outlined" color="inherit" onClick={() => setShowMoreDetails(!showMoreDetails)}>
              Show details
            </Button>
          )
        }
      >
        {message}
        {customAction && <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>{customAction}</Box>}
      </Alert>

      {detail && (
        <Dialog open={showMoreDetails} onClose={() => setShowMoreDetails(false)}>
          <DialogHeader title={`Error ${code}`} onClose={() => setShowMoreDetails(false)}></DialogHeader>
          <DialogContent>
            <CodeAreaField
              options={{ readOnly: true, lineNumbers: false, mode: null }}
              variant="filled"
              copyValue={detail}
              value={detail}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default ErrorAlert
